var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"mainContainer"}},[_c('div',{attrs:{"id":"playBtn","target":"Games"}},[_c('i',{staticClass:"icon",attrs:{"id":"playBtnIcn"}},[_vm._v("")]),_vm._v(" "),_c('div',{attrs:{"id":"clock"}},[_vm._v("--- : --- : ---")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32b50118","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = xJA7
// module chunks = 0